import {initWebComponent} from "@/helpers/web-component-helper";
import {LayoutTopNavBarItemComponent} from "@/components/layout/layout-top-nav-bar-item-component";

export class LayoutTopNavBarComponent extends HTMLElement {
    constructor() {
        super();

        const template = document.createElement('template');
        template.innerHTML = `
      <nav id="topNavBar" class="navbar w-100 navbar-expand-lg bg-white p-0 position-fixed d-none d-md-flex" style="z-index: 20">
        <div class="" id="divNavbar" style="">
          <ul class="navbar-nav ml-3" id="ulNavbar">
            <layout-top-nav-bar-item data-active="active" data-child-component="melding-wizard" data-title="Melding"></layout-top-nav-bar-item>
            <layout-top-nav-bar-item data-active="" data-child-component="page-guidelines" data-title="Richtlijnen"></layout-top-nav-bar-item>
          </ul>
        </div>
        <div class="app-brand demo mr-5 mr-auto ml-auto">
          <span class="app-brand-logo">
          </span>
          </div>
        <ul class="navbar-nav align-items-lg-center mr-4">
             <img src="${window.kaartViewerUrl}/admin/rest/openapi/${window.websiteName}/logo" class="float-right" style="max-height: 75px" alt="">
          </ul>
      </nav>

    <nav id="topNavBarMobile" class="navbar w-100 p-0 position-fixed d-block d-md-none" style="z-index: 20">

        <div class="row">
            <div class="col-6 pr-0">
                <layout-top-nav-bar-item data-active="active" data-child-component="melding-wizard" data-title="Melding"></layout-top-nav-bar-item>
            </div>
            <div class="col-6 pl-0">
                <layout-top-nav-bar-item data-active="" data-child-component="page-guidelines" data-title="Richtlijnen"></layout-top-nav-bar-item>
            </div>
        </div>
    </nav>`;
        initWebComponent(this, template)
    }
}


window.customElements.define("layout-top-nav-bar-item", LayoutTopNavBarItemComponent);
